import React, { useState } from 'react';
import Modal from '../Modal';

export default function ModalImage(props: {
    image: string;
    alt: string;
    className?: string;
    notChangeOverflow?: boolean;
}) {
    const [show, setShow] = useState<boolean>(false);
    return (
        <>
            <Modal
                width={600}
                show={show}
                showClose={true}
                onClose={() => setShow(false)}
                notChangeOverflow={props.notChangeOverflow}>
                <div className={'flex justify-center p-4'}>
                    <img src={props.image} alt={props.alt} />
                </div>
            </Modal>
            <img
                onClick={() => setShow(true)}
                className={`cursor-pointer ${props.className}`}
                src={props.image}
                alt={props.alt}
            />
        </>
    );
}
